import { render, staticRenderFns } from "./PrintOnlyObjectComp.vue?vue&type=template&id=548acb08"
import script from "./PrintOnlyObjectComp.vue?vue&type=script&lang=ts"
export * from "./PrintOnlyObjectComp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports